// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import { makeStyles, Breadcrumbs, Icon, IconButton, Link } from '@material-ui/core';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    minHeight: '31px',
    padding: theme.spacing(2, 3),
  },
  home: {
    paddingTop: '2px',
  },
  arrow: {
    marginTop: '-1px',
  },
  disabled: {
    pointerEvents: 'none',
  },
}));

function AppBreadcrumbs() {
  const [t] = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  const pathnames = location.pathname.split('/').filter(pathname => pathname);

  const handleBack = () => {
    const previousPath = `/${pathnames.slice(0, pathnames.length - 1).join('/')}`;
    history.push(_.defaultTo(location.state?.from, previousPath));
  };

  return (
    <Breadcrumbs id="AppBreadcrumbs" aria-label="breadcrumbs" className={classes.root}>
      {pathnames.length > 1 ? (
        <IconButton
          id="AppBreadcrumbs-back"
          aria-label="back"
          size="small"
          className={classes.arrow}
          onClick={handleBack}
        >
          <Icon>arrow_back</Icon>
        </IconButton>
      ) : (
        <Icon className={classes.home}>home</Icon>
      )}
      {pathnames.map((pathname, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        return (
          <Link
            component={RouterLink}
            className={classes.disabled}
            color="inherit"
            to={to}
            key={to}
          >
            {t(`nav.${pathname}`, pathname)}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default AppBreadcrumbs;
